module.exports = __webpack_public_path__ + "img/ZGPA.be033621.png";